import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { File } from "../../common/_types/file";
import { WorkerFileType } from "./worker-file-type";

export class WorkerFile extends Resource {
    public override type = 'workerFiles';

    @prop()
    @required()
    public workerId!: string;

    public worker!: Worker;

    @prop()
    public workerFileTypeId!: string;

    public workerFileType!: WorkerFileType;

    @prop()
    public fileId!: string;

    public file!: File;

    @prop()
    public name!: string;

    @prop()
    public notes!: string;

    @prop()
    public expirationDate!: Date;
    
    @prop()
    public processedExpiration: boolean = false;
}